var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingApprovalClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 9.99466,
    height: 9.99466,
    viewBox: "0 0 9.99466 9.99466",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.99733 9.16177C7.29729 9.16177 9.16177 7.29729 9.16177 4.99733C9.16177 2.69737 7.29729 0.832888 4.99733 0.832888C2.69737 0.832888 0.832888 2.69737 0.832888 4.99733C0.832888 7.29729 2.69737 9.16177 4.99733 9.16177Z",
    stroke: "#E17100",
    strokeWidth: 0.832888
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.99733 2.49867V4.99733L6.66311 5.83022",
    stroke: "#E17100",
    strokeWidth: 0.832888
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.99466,
    height: 9.99466,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingApprovalClock);
export default __webpack_public_path__ + "static/media/pending-approval-clock.b878648574f672e9533265ec29974d0e.svg";
export { ForwardRef as ReactComponent };